<template>
    <v-container style="padding-top: 80px">
        <v-row mb-2>
            <v-chip class="ma-2 chipSize" :color="this.colorReporte" style="align-self: center" large
                @click="detalleReporte()">
                <span class="txtRep"> Reporte: {{ this.RepInd }} </span>
            </v-chip>

            <v-chip :class="colorClass" class="chipSize" style="align-self: center" large>
                <span class="txtEtiq">
                    {{ this.etiqueta }}
                </span>
            </v-chip>
        </v-row>
        <v-card class="mt-2 pb-0 mb-5">
            <v-card-title class="pa-5 pb-3 primary">
                <p style="color: white;"> Datos de prueba </p>
            </v-card-title>

            <v-card-text style="margin-bottom: 4%;">
                <v-row justify="center">
                    <v-col cols="12" md="6">
                        <div class="mt-3">
                            <v-form ref="form" v-model="validForm" lazy-validation>
                                <h4 class="text-info" style=" font-size: 18px; font-weight: bold;">
                                    Seleccione los datos de Prueba
                                </h4>
                                <v-row>
                                    <v-col md="12">
                                        <div v-for="(item, index) in datosPrueba" :key="index">
                                            <v-list-item>
                                                <v-list-item-action class="mr-1">
                                                    <v-checkbox :value="item.cdpclave" v-model="valDatoPrueba"></v-checkbox>
                                                </v-list-item-action>
                                                <v-list-item-content class="document-chekboxes-style">
                                                    {{ item.cdpdescripcion }}
                                                </v-list-item-content>
                                            </v-list-item>
                                        </div>
                                        <span v-if="valdatosPruebas" class="error-message-style mb-3">Debe seleccionar al
                                            menos una opción</span>
                                        <v-divider class="mt-1"></v-divider>
                                        <div v-if="mostrarOpcTec">
                                            <div v-for="(item, i) in opcionTec" :key="i" class="ml-5">
                                                <v-list-item>
                                                    <v-list-item-action class="mr-1">
                                                        <v-checkbox :value="item.otclave"
                                                            v-model="valOpcTecnica"></v-checkbox>
                                                    </v-list-item-action>
                                                    <v-list-item-content class="document-chekboxes-style">
                                                        {{ item.otdescripcion }}
                                                    </v-list-item-content>
                                                </v-list-item>
                                            </div>
                                            <span v-if="valopcionTec" class="error-message-style mb-3">Debe seleccionar al
                                                menos
                                                una
                                                opción</span>
                                            <v-divider class="mt-1"></v-divider>
                                        </div>
                                    </v-col>

                                </v-row>
                                <br />

                            </v-form>
                        </div>
                    </v-col>
                </v-row>
            </v-card-text>

            <v-card-actions style="justify-content: center; align-content:end; padding: 20px;">
                <v-row justify="center" class="mb-8">
                    <v-btn class="ma-2" color="#536DFE" style="color:white" :disabled="disBtn"
                        @click="Guardar()">Guardar</v-btn>
                    <v-btn class="ma-2" color="default" title="Limpiar" @click="limpiar()" :disabled="disBtn">
                        Limpiar
                    </v-btn>
                    <v-btn class="ma-2" color="error" @click="Cancelar()" :disabled="disBtn">Cancelar</v-btn>
                </v-row>
            </v-card-actions>
        </v-card>
    </v-container>
</template>

<script>
import MetodosGenerales from '@/utils/metodosgenerales.vue.js';
import Lideres from "@/services/Lideres/Lideres.service.js";
import SerBusqueda from '@/services/Busqueda/Busqueda.service.js';

import { mapState } from "vuex";
    export default {
        title() {
            return this.$route.meta.title
        },
    data() {
        return {
            datosPrueba: [],
            valopcionTec: false,
            valdatosPruebas: false,
            valDatoPrueba: [],
            valOpcTecnica: [],
            disBtn: false,
            validForm: true,
            reporte: {
                nrreporte: 0,
                svindice: 0
            },
            permisoLideres: false,
            mostrarOpcTec: false,
            opcionTec: [],
            colorReporte: '',
            RepInd: '',
            colorClass: "",
            etiqueta: '',
            asistenciaurl: '',

        }
    },
    computed: {
        ...mapState(['domain', 'informationPage']),
    },
    watch: {
        etiqueta(val) {
            if (val == "Abierto") {
                this.colorClass = "marginChip";
            } else if (val == "Concluido") {
                this.colorClass = "marginChipRed";
            } else if (val == "Cancelado") {
                this.colorClass = "marginChipPurple";
            } else if (val == "Conclusión Administrativa") {
                this.colorClass = "marginChipYellow";
            }
        },
        'valDatoPrueba'(val) {
            this.valdatosPruebas = false
            if (this.valDatoPrueba.includes(8)) {
                this.mostrarOpcTec = true;
                this.CatalogoOpcionTecnica();
            } else {
                this.mostrarOpcTec = false;
                this.valOpcTecnica = [];
            }
        },
        'valOpcTecnica'(val) {
            this.valopcionTec = false;
        }
    },
    async beforeMount() {
        await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '40').then(response => {
            if (response.data.length > 0) {
                response.data.forEach(permiso => {
                    if (permiso.peclave == 40)//Permiso para ver lideres
                        this.permisoLideres = true;
                });
            }
            if (this.permisoLideres == false) {
                this.$router.push({ name: `NoAutorizado` }).catch(error => error);
            }
        });
    },
    async mounted() {
        let reporte = await MetodosGenerales.obtenerSessionReporte('valider');
        this.reporte.nrreporte = reporte.nrreporte;
        this.reporte.svindice = reporte.svindice;
        this.reporte.aiclave = reporte.aiclave;
        this.reporte.svfhconclusion = reporte.svfhconclusion;

        await Lideres.CatalogoDatosPrueba(this);
        let movimientoResponse = await Lideres.ObtenerDatosPruebaReporteInforme(this.reporte);
        if (movimientoResponse.length > 0) {
            this.valDatoPrueba = movimientoResponse[0].dprseleccion.split(',').map(Number);
            this.valOpcTecnica = typeof movimientoResponse[0].dpropiontecnica != 'object' ? movimientoResponse[0].dpropiontecnica.split(',').map(Number) : [];
        }
        let encabezado = await Lideres.EncabezadoReporte(this.reporte);
        this.RepInd = encabezado.nrreportei;
        this.colorReporte = encabezado.color;
        this.etiqueta = encabezado.etiqueta;

        this.asistenciaurl = await MetodosGenerales.ObtenerURL(this.reporte);
    },
    methods: {
        async detalleReporte() {
            let reporte = {
                nrreporte: this.reporte.nrreporte,
                svindice: this.reporte.svindice,
                aiclave: this.reporte.aiclave,
                svfhconclusion: this.reporte.svfhconclusion
            };
            var ver = 0;
            let formData = new FormData();
            formData.append("nrreporte", this.reporte.nrreporte);
            formData.append("svindice", this.reporte.svindice);
            await SerBusqueda.ObtenerValidacion(this, formData).then(data => {
                ver = data;
            });
            if (ver == 0) {
                this.$router.push({ name: `${"DatosIncompletos"}` }).catch(error => error);
            }
            else {
                await MetodosGenerales.guardarEnSesionInfoReporte(this.reporte, 'reporte');
                this.$router.push({ name: `${"Asistencias"}` });


            }
        },
        limpiar() {
            this.valDatoPrueba = [];
            this.valOpcTecnica = [];
        },
        Cancelar() {
            this.$router.push({ name: `AgregarMovimientoValider` }).catch(error => error);
        },
        async CatalogoOpcionTecnica() {
            await Lideres.CatalogoOpcionTecnica(this, 8);
        },
        async Guardar() {
            this.$refs.form.validate();
            if (this.valDatoPrueba.length == 0) { this.valdatosPruebas = true }
            if (this.mostrarOpcTec == true && this.valOpcTecnica.length == 0) { this.valopcionTec = true }

            if (this.valdatosPruebas == false && this.valopcionTec == false) {
                this.disBtn = true;
                this.$swal({
                    title: 'Procesando solicitud',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: async () => {
                        this.$swal.showLoading();
                        let response = await Lideres.GuardarDatosPrueba(this.reporte, this.valDatoPrueba.join(), this.valOpcTecnica.join());
                        if (response == true) {
                            this.$swal({
                                position: "center",
                                icon: "success",
                                title: "Correcto",
                                text: "Datos guardados correctamente.",
                                showConfirmButton: true,
                                allowOutsideClick: false,
                                confirmButtonColor: '#536DFE',
                                confirmButtonText: 'Aceptar',
                                timer: 2500,
                            }).then(() => {
                                this.$router.push({ name: `AgregarMovimientoValider` }).catch(error => error);
                            });
                        } else {
                            this.$swal({
                                position: "center",
                                icon: "warning",
                                title: "Error",
                                text: "Ocurrió un error, intente nuevamente más tarde, si el problema persiste, pónganse en contacto con el área de soporte.",
                                showConfirmButton: false,
                                allowOutsideClick: false,
                                timer: 2500,
                            });
                            this.disBtn = false;
                        }
                    }
                });
            }
        }
    }
}
</script>

<style scoped>
.error-message-style {
    font-family: "Roboto", sans-serif;
    color: #FF5C93;
    font-weight: 400;
    font-size: 12px;
}
</style>